import { jsx as _jsx } from "react/jsx-runtime";
import { ThemeColorVariable, } from '@caspeco/casper-ui-library.base-ui.theme';
import { Divider as ChakraDivider, } from '@chakra-ui/react';
/**
 * Layout component used to visually separate content in a list or group.
 * It displays a thin horizontal or vertical line, and renders a hr tag.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/divider
 */
export function Divider({ borderColor = ThemeColorVariable.OnBackgroundBorder, orientation = 'horizontal', ...props }) {
    return (_jsx(ChakraDivider, { borderColor: borderColor, orientation: orientation, ...props }));
}
//# sourceMappingURL=divider.js.map